import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { GalleryHeadingRoutingModule } from './gallery-heading-routing.module';
import { GalleryHeadingListComponent } from './gallery-heading-list/gallery-heading-list.component';
import { GalleryHeadingCreateComponent } from './gallery-heading-create/gallery-heading-create.component';

@NgModule({
  declarations: [GalleryHeadingListComponent, GalleryHeadingCreateComponent],
  imports: [
    CommonModule,
    GalleryHeadingRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class GalleryHeadingModule { }
